import {
  DashboardOutlined,
  FileSearchOutlined,
  UserAddOutlined,
  SearchOutlined,
  AuditOutlined,
  FileDoneOutlined,
  CaretDownOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SideBar as MySidebar } from '../styles';

const keyCpap = (key: string, keyValid: string[]): string => {
  if (keyValid.find((k) => k === key)) {
    return key;
  }
  return '';
};

const SideBar: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <MySidebar>
      <Menu style={{ background: '#ecffb8' }} selectedKeys={[pathname]}>
        <Menu.Item className="menuItem" key="/" icon={<DashboardOutlined width={30} />}>
          <Link to="/" className="title3">
            ダッシュボード
          </Link>
        </Menu.Item>
        <div className="titleMenuBox a">
          <div className="titleMenu">
            <p className="title3">CPAP指示書管理</p>
          </div>
          <div className="triangle" />
        </div>
        <Menu.Item className="menuItem1" key="/cpap/register" icon={<UserAddOutlined />}>
          <Link to="/cpap/register" className="title3">
            新規患者登録
          </Link>
        </Menu.Item>
        <Menu.Item
          className="menuItem1"
          key={keyCpap(pathname, ['/cpap', '/cpap/detail', '/cpap/edit'])}
          icon={<SearchOutlined />}
        >
          <Link to="/cpap" className="title3">
            CPAP指示書一覧・検索
          </Link>
        </Menu.Item>
        <div className="titleMenuBox">
          <div className="titleMenu">
            <p className="title3">請求書管理</p>
          </div>
          <div className="triangle" />
        </div>
        <Menu.Item
          className="menuItem1"
          key={keyCpap(pathname, ['/billing_process', '/billing_process/register'])}
          icon={<AuditOutlined />}
        >
          <Link to="/billing_process" className="title3">
            請求処理
          </Link>
        </Menu.Item>
        <Menu.Item
          className="menuItem1"
          key={keyCpap(pathname, ['/billings', '/billings/detail'])}
          icon={<UserAddOutlined />}
        >
          <Link to="/billings" className="title3">
            請求書一覧
          </Link>
        </Menu.Item>
        <Menu.Item className="menuItem1" key="/consultation_history" icon={<FileSearchOutlined />}>
          <Link to="/consultation_history" className="title3">
            患者別受診履歴
          </Link>
        </Menu.Item>
        <div className="titleMenuBox">
          <div className="titleMenu">
            <p className="title3">入金管理</p>
          </div>
          <div className="triangle" />
        </div>
        <Menu.Item className="menuItem1" key="/payouts" icon={<FileDoneOutlined />}>
          <Link to="/payouts" className="title3">
            入金処理
          </Link>
        </Menu.Item>
        <div className="last" />
        <div className="titleMenu1 ">
          <CaretDownOutlined className="titleMenu2" />
          <span className="title3"> 機器管理</span>
        </div>
        <Menu.Item className="menuItem1" key="/machine/register" icon={<EditOutlined />}>
          <Link to="/machine/register" className="title3">
            新規登録
          </Link>
        </Menu.Item>
        <Menu.Item
          className="menuItem1"
          key={keyCpap(pathname, ['/machine', '/machine/detail', '/machine/edit', '/machine/update'])}
          icon={<SearchOutlined />}
        >
          <Link to="/machine" className="title3">
            リース契約一覧・検索
          </Link>
        </Menu.Item>
        <div className="titleMenu1 ">
          <CaretDownOutlined className="titleMenu2" />
          <span className="title3"> 医療機関管理</span>
        </div>
        <Menu.Item className="menuItem1" key="/medical_institution/register" icon={<EditOutlined />}>
          <Link to="/medical_institution/register" className="title3">
            新規登録
          </Link>
        </Menu.Item>
        <Menu.Item className="menuItem1" key="/medical_institution" icon={<SearchOutlined />}>
          <Link to="/medical_institution" className="title3">
            医療機関一覧・検索
          </Link>
        </Menu.Item>
      </Menu>
    </MySidebar>
  );
};

export default SideBar;
